"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("../index.vue");
var _ForgotForm = _interopRequireDefault(require("./ForgotForm.vue"));
var _LoginProfessional = _interopRequireDefault(require("./LoginProfessional.vue"));
var _vuexModuleDecorators = require("vuex-module-decorators");
var _user = _interopRequireDefault(require("@/store/modules/user"));
var _OtpModal = _interopRequireDefault(require("./OtpModal.vue"));
var LoginForm = /*#__PURE__*/function (_Vue) {
  function LoginForm() {
    var _this;
    (0, _classCallCheck2.default)(this, LoginForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, LoginForm, [].concat(args));
    (0, _defineProperty2.default)(_this, "userStore", (0, _vuexModuleDecorators.getModule)(_user.default, _this.$store));
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "showPass", false);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "rules", {
      username: {
        required: true,
        trigger: "submit",
        message: "Field is required"
      },
      password: {
        required: true,
        trigger: "submit",
        message: "Field is required"
      }
    });
    (0, _defineProperty2.default)(_this, "visibleForgot", false);
    (0, _defineProperty2.default)(_this, "StatusPage", _index.StatusPage);
    return _this;
  }
  (0, _inherits2.default)(LoginForm, _Vue);
  return (0, _createClass2.default)(LoginForm, [{
    key: "created",
    value: function created() {}
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$refs.form.validate();
            case 2:
              this.loadingSubmit = true;
              this.userStore.login(this.form).then(function (res) {
                _this2.$refs.OtpModal.handleOpen(_this2.form);
                // this.$router.push("/");
              }).finally(function () {
                return _this2.loadingSubmit = false;
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
LoginForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    LoginProfessional: _LoginProfessional.default,
    ForgotForm: _ForgotForm.default,
    OtpModal: _OtpModal.default
  }
})], LoginForm);
var _default = exports.default = LoginForm;